import { STGrouping } from '@tencent/slide-sdk-model';
import { SubChartType } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';
import { ChartShapeInfoConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/chart/common/chart-shape-info-converter';
import { setUIValueToSdkData } from '@src/slide/domain/ui-model/element-modeles/chart-models/sub-chart/properties/util';
import _has from 'lodash/has';
import type { IChartBaseShapeProps } from '@src/slide/domain/ui-model/converter/node-property/module-property/chart/common/chart-shape-info-converter';
import type { ICTTrendline, STTrendlineType } from '@tencent/slide-sdk-model';
import type { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';

export class Trendline {
    public static convertDataUiToSdk(uiData) {
        if (!uiData) {
            return uiData;
        }

        const sdkData: ICTTrendline = {};

        if (_has(uiData, 'name')) {
            setUIValueToSdkData(sdkData, 'name', uiData.name, false);
        }
        if (_has(uiData, 'period')) {
            setUIValueToSdkData(sdkData, 'period', uiData.period);
        }
        if (_has(uiData, 'order')) {
            setUIValueToSdkData(sdkData, 'order', uiData.order);
        }
        if (_has(uiData, 'forward')) {
            setUIValueToSdkData(sdkData, 'forward', uiData.forward);
        }
        if (_has(uiData, 'backward')) {
            setUIValueToSdkData(sdkData, 'backward', uiData.backward);
        }
        if (_has(uiData, 'dispEq')) {
            setUIValueToSdkData(sdkData, 'dispEq', uiData.dispEq);
        }
        if (_has(uiData, 'dispRSqr')) {
            setUIValueToSdkData(sdkData, 'dispRSqr', uiData.dispRSqr);
        }

        ChartShapeInfoConverter.convertPartialDataFromUiToSdk(uiData, sdkData);

        if (_has(uiData, 'type')) {
            setUIValueToSdkData(sdkData, 'trendlineType', uiData.type);
        }

        return sdkData;
    }

    public props;
    public type?: STTrendlineType;
    public name?: string;
    public dispEq?: boolean; // 是否显示公式
    public dispRSqr?: boolean; // 显示R平方值

    public period?: number;    // 周期，移动平均的属性
    public order?: number;     // 多项式阶数，多项式的属性
    public forward?: number;   // 趋势预测 前推周期
    public backward?: number;   // 趋势预测 后推周期
    public seriesId?: string;   // 用于trendLine定位所属series
    public idx?: number;        // 在trendlines的索引

    public constructor(sdkData: ICTTrendline, seriesId, idx) {
        const { trendlineType, period, order, forward, backward, name, dispEq, dispRSqr } = sdkData;

        this.name = name;
        this.type = trendlineType?.val;
        this.period = period?.val;
        this.order = order?.val;
        this.forward = forward?.val;
        this.backward = backward?.val;
        this.dispEq = !!dispEq?.val;
        this.dispRSqr = !!dispRSqr?.val;
        this.seriesId = seriesId;
        this.idx = idx;

        ChartShapeInfoConverter.convertPartialDataFromSdkToUi(
            sdkData as IChartBaseShapeProps,
            this as unknown as IShapeModel,
        );
    }
}

// eslint-disable-next-line complexity
export function getAvailableTrendline(chartType: SubChartType, grouping?: STGrouping) {
    switch (chartType) {
        case SubChartType.BarChart:
        case SubChartType.Bar3DChart:
        case SubChartType.LineChart:
        case SubChartType.Line3DChart:
            return grouping !== STGrouping.stacked && grouping !== STGrouping.percentStacked;
        case SubChartType.ScatterChart:
        case SubChartType.BubbleChart:
            return true;
        case SubChartType.PieChart:
        case SubChartType.Pie3DChart:
        case SubChartType.DoughnutChart:
        case SubChartType.RadarChart:
        case SubChartType.AreaChart:
        case SubChartType.Area3DChart:
            return false;
        default:
            return false;
    }
}
